import {
  PROJECT,
  TYPE_LIST,
  SUB_TYPE_LIST,
  STATUS_LIST,
  TEAM_MEMBER_LIST,
  SEARCH_RESULT_LIST,
  RESOLUTION_TYPE_LIST,
  SUBJECT_FIELD,
  TYPE_FIELD,
  SUB_TYPE_FIELD,
  REF_NO_FIELD,
  REF_TYPE_FIELD,
  BATCH_ID_FIELD,
  DETAIL_FIELD,
  ASSIGN_TO_FIELD,
  VENDOR_NAME_FIELD,
  VENDOR_NAME2_FIELD,
  VENDOR_CODE_FIELD,
  STATUS_NOTE_FIELD,
  RESOLUTION_FIELD,
  RESOLUTION_TYPE_FIELD,
  ASSIGNED_DATE_FIELD,
  RESOLVED_DATE_FIELD,
  SHIP_CANCEL_DATE_FIELD,
  INDC_DATE_FIELD,
  COO_FIELD,
  DROP_DOWN_VALUES_RETRIEVED,
  DEFAULT_PRIORITY,
  DEFAULT_TRACKER,
  DEFAULT_STATUS,
  DEFAULT_TYPE,
  DEFAULT_SUB_TYPE,
  DEFAULT_RESOLUTION_TYPE,
  SEARCH_RESULT_LIST_SELECTED,
  IS_TEAM_LEADER,
  IS_TEAM_MEMBER,
  IS_VENDOR,
  VENDOR_NAME_TO_ID_MAP,
  VENDOR_ID_TO_NAME_MAP,
  TEAM_MEMBER_ID_TO_NAME_MAP,
  TEAM_LEADER_EMAIL_MAP,
  SHAREPOINT_FOLDER_ID,
  ATTACHMENT_INFO_FIELD,
  WORKFLOW,
  WORKFLOW_PERMISSION,
  BRAND_FIELD,
  SEARCH_CRITERIA,
  REDMINE_ROLE_ID,
  CUSTOM_FIELD_VISIBILITIES,
  VENDOR_LIST
} from './definition'
import {
  ACCESS_GROUPS
} from 'src/store/definition'

export default {
  [PROJECT] (state) {
    return state.project.defaultValue ? state.project : null
  },
  [TYPE_LIST] (state) {
    return state['Type'].list
  },
  [SUB_TYPE_LIST] (state) {
    return state['Sub Type'].list
  },
  [STATUS_LIST] (state) {
    return state.status.list
  },
  [TEAM_MEMBER_LIST] (state) {
    return state.teamMembers
  },
  [SEARCH_RESULT_LIST] (state) {
    return state.searchResultList
  },
  [RESOLUTION_TYPE_LIST] (state) {
    return state['Resolution Type'].list
  },
  [SUBJECT_FIELD] (state) {
    return state.subject.field
  },
  [TYPE_FIELD] (state) {
    return state['Type'].field
  },
  [SUB_TYPE_FIELD] (state) {
    return state['Sub Type'].field
  },
  [REF_NO_FIELD] (state) {
    return state['Ref No'].field
  },
  [REF_TYPE_FIELD] (state) {
    return state['Ref Type'].field
  },
  [BATCH_ID_FIELD] (state) {
    return state['Batch ID'].field
  },
  [DETAIL_FIELD] (state) {
    return state['Detail'].field
  },
  [ASSIGN_TO_FIELD] (state) {
    return state['Assign To'].field
  },
  [VENDOR_NAME_FIELD] (state) {
    return state['Vendor Name'].field
  },
  [VENDOR_NAME2_FIELD] (state) {
    return state['Vendor Name2'].field
  },
  [VENDOR_CODE_FIELD] (state) {
    return state['Vendor Code'].field
  },
  [RESOLUTION_FIELD] (state) {
    return state['Resolution'].field
  },
  [STATUS_NOTE_FIELD] (state) {
    return state['Status Note'].field
  },
  [RESOLUTION_TYPE_FIELD] (state) {
    return state['Resolution Type'].field
  },
  [ASSIGNED_DATE_FIELD] (state) {
    return state['Assigned Date'].field
  },
  [RESOLVED_DATE_FIELD] (state) {
    return state['Resolved Date'].field
  },
  [SHIP_CANCEL_DATE_FIELD] (state) {
    return state['Anticipated Ship cancel date'].field
  },
  [INDC_DATE_FIELD] (state) {
    return state['INDC Date'].field
  },
  [COO_FIELD] (state) {
    return state['COO'].field
  },
  [DROP_DOWN_VALUES_RETRIEVED] (state) {
    return state.dropDownValuesRetrieved
  },
  [DEFAULT_PRIORITY] (state) {
    let { field, defaultValue } = state.priority
    return { field, ...state.priority.list.find(item => item.id === defaultValue) }
  },
  [DEFAULT_TRACKER] (state) {
    let { field, defaultValue } = state.tracker
    return { field, ...state.tracker.list.find(item => item.id === defaultValue) }
  },
  [DEFAULT_STATUS] (state) {
    let { field, defaultValue } = state.status
    return { field, ...state.status.list.find(item => item.id === defaultValue) }
  },
  [DEFAULT_TYPE] (state) {
    let { field, defaultValue } = state['Type']
    return { field, ...state['Type'].list.find(item => item.id === defaultValue) }
  },
  [DEFAULT_SUB_TYPE] (state) {
    let { field, defaultValue } = state['Sub Type']
    return { field, ...state['Sub Type'].list.find(item => item.id === defaultValue) }
  },
  [DEFAULT_RESOLUTION_TYPE] (state) {
    let { field, defaultValue } = state['Resolution Type']
    return { field, ...state['Resolution Type'].list.find(item => item.id === defaultValue) }
  },
  [SEARCH_RESULT_LIST_SELECTED] (state) {
    return state.searchResultListSelected
  },
  [IS_TEAM_LEADER] (state, getters) {
    // return getters[ACCESS_GROUPS].reduce((accessModels, accessGroup) => {
    //   accessModels.push(...accessGroup.accessModelList)
    //   return accessModels
    // }, []).some(accessModel => {
    //   return accessModel.accessRole === 'APPROVER' &&
    //          accessModel.accessModule === 'SOURCING_WF' &&
    //          accessModel.accessFunction === 'SERVICE_REQUEST'
    // })
    return getters[ACCESS_GROUPS].some(accessGroup => {
      return accessGroup.accessGroup === 'SERVICE_REQUEST_APPROVE'
    })
  },
  [IS_TEAM_MEMBER] (state, getters) {
    // return getters[ACCESS_GROUPS].reduce((accessModels, accessGroup) => {
    //   accessModels.push(...accessGroup.accessModelList)
    //   return accessModels
    // }, []).some(accessModel => {
    //   return accessModel.accessRole === 'EDITOR' &&
    //          accessModel.accessModule === 'SOURCING_WF' &&
    //          accessModel.accessFunction === 'SERVICE_REQUEST'
    // })
    return getters[ACCESS_GROUPS].some(accessGroup => {
      return accessGroup.accessGroup === 'SERVICE_REQUEST_EDIT'
    })
  },
  [IS_VENDOR] (state, getters) {
    // return getters[ACCESS_GROUPS].reduce((accessModels, accessGroup) => {
    //   accessModels.push(...accessGroup.accessModelList)
    //   return accessModels
    // }, []).some(accessModel => {
    //   return accessModel.accessRole === 'CREATOR' &&
    //          accessModel.accessModule === 'SOURCING_WF' &&
    //          accessModel.accessFunction === 'SERVICE_REQUEST'
    // })
    return getters[ACCESS_GROUPS].some(accessGroup => {
      return accessGroup.accessGroup === 'SERVICE_REQUEST_CREATE'
    })
  },
  [VENDOR_NAME_TO_ID_MAP] (state) {
    return state.vendorNameToIdMap
  },
  [VENDOR_ID_TO_NAME_MAP] (state) {
    return state.vendorIdToNameMap
  },
  [TEAM_MEMBER_ID_TO_NAME_MAP] (state) {
    return state.teamMemberIdToNameMap
  },
  [TEAM_LEADER_EMAIL_MAP] (state) {
    return state.teamLeaderEmailMap
  },
  [SHAREPOINT_FOLDER_ID] (state) {
    return state.sharepointFolderId
  },
  [ATTACHMENT_INFO_FIELD] (state) {
    return state['Attachment Info'].field
  },
  [WORKFLOW] (state) {
    return state.workflow
  },
  [WORKFLOW_PERMISSION] (state) {
    return state.workflowPermission
  },
  [BRAND_FIELD] (state) {
    return state['Brand'].field
  },
  [SEARCH_CRITERIA] (state) {
    return state.searchCriteria
  },
  [REDMINE_ROLE_ID] (state) {
    return state.redmineRoleId
  },
  [CUSTOM_FIELD_VISIBILITIES] (state) {
    return state.customFieldVisibilities
  },
  [VENDOR_LIST] (state) {
    return state.vendorList
  }
}



// WEBPACK FOOTER //
// ./src/components/sourcing_workflow/service_request/store/getters.js